module.exports = __webpack_public_path__ + "img/taiyu.1074f2af.jpg";